import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { ExposedListPowerBIReportsRes } from 'app/interfaces/responses/Exposed/exposedListPowerBIReportsRes';
import { ExposedReadPowerBIReportsRes } from 'app/interfaces/responses/Exposed/exposedReadPowerBIReportsRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PowerBIService {
    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private alertsService: AlertsService,
        private router: Router,
        public dialog: MatDialog
    ) {}

    public getReport(reportKey: string, showError = true): Observable<ExposedReadPowerBIReportsRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki mælaborð');

        let subject = new Subject<ExposedReadPowerBIReportsRes>();
        this.http
            .get(environment.localApi + 'powerbi/getReport/' + encodeURIComponent(btoa(reportKey)))
            .subscribe({
                next: (res: HttpStatus<ExposedReadPowerBIReportsRes>) => {
                    subject.next(res.returnItem);
                },
                error: (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                },
            })
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public getReportList(showError = true, showLoaderMessage = true): Observable<ExposedListPowerBIReportsRes[]> {
        this.loaderService.changeActiveLoaders(1);
        if (showLoaderMessage) {
            this.loaderService.changeLoaderMessage('Sæki skýrslur');
        }

        let subject = new Subject<ExposedListPowerBIReportsRes[]>();
        this.http
            .get(environment.localApi + 'powerbi/listReports')
            .subscribe({
                next: (res: HttpStatus<ExposedListPowerBIReportsRes[]>) => {
                    subject.next(res.returnItem);
                },
                error: (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                },
            })
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }
}
